import type { ReactNode } from 'react';
import Brand from '@/components/structures/Brand';

/** Totem da cabine (tela vertical, sem menu, alvos de toque grandes — C-01 kiosk / RN-107). */
export default function KioskLayout({ right, children }: { right?: ReactNode; children: ReactNode }) {
  return (
    <div className="kiosk">
      <header className="appbar"><Brand /><span className="ctx">{right}</span></header>
      <main className="kiosk-main fade-in">{children}</main>
      <div className="kiosk-foot">CABINE MÉDICO ONLINE</div>
    </div>
  );
}
